import { useEffect, useState } from "react";

/** Helpers */
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GenerateMeta } from "@/src/_common/useHelper";
import { TranslationFromJson } from "@/src/_common/useHelper";

/** Nextjs */
import dynamic from "next/dynamic";
import Head from "next/head";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";

/** Redux */
import { useDispatch, useSelector } from "react-redux";
import { fetchStorytellingFromIndexedDB, getFetched, setFetched } from "../../src/_appStore/Storytelling";

/** API */
import { getHomepageAreasFromAPI } from "../../src/_APIs";

/** UI */
// const OneAreaPage = dynamic(() => import("../../src/pages/_Obszary/Index/_one_area"));
import MetaHeadSEO from "@/src/_common/MetaHeadSEO";
import OneAreaPage from "@/src/pages/_Obszary/Index/_one_area";
const StorytellingLayout = dynamic(() => import("../../src/layouts/StorytellingLayout/StorytellingLayout"));
const Preloader = dynamic(() => import("../../src/_common/Preloader"));
// import StorytellingLayout from "@/src/layouts/StorytellingLayout/StorytellingLayout";
// import Preloader from "@/src/_common/Preloader";

const Storytelling = (props) => {
    const { metaTitle, metaDescription, areas, area, sid } = props;

    const { i18n } = useTranslation();
    const dispatch = useDispatch();
    const router = useRouter();

    const [AREA, setAREA] = useState(null);
    const _fetched = useSelector(getFetched);

    useEffect(() => {
        if (_fetched) return;
        Promise.all([dispatch(fetchStorytellingFromIndexedDB())])
            .then(() => {
                dispatch(setFetched(true));
            })
            .catch(
                (err) =>
                    process.env.NODE_ENV === "development" &&
                    console.log("%c Valirization: error", "background:#F00", err),
            );
    }, [_fetched]);

    useEffect(() => {
        getAreas()
            .then((res) => {
                if (res && res?.hasOwnProperty("name")) {
                    setAREA(res);
                } else {
                    router.push(`/${i18n.language}/404`);
                }
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {});

        return () => {
            setAREA(null);
        };
    }, [area]);

    const getAreas = async () => {
        const areas = await getHomepageAreasFromAPI();
        const area =
            areas instanceof Array
                ? {
                      ...areas?.find((a) => a.areaID?.toString() === sid[0]?.toString()),
                      id: Number(sid[0] || 0),
                  }
                : {};
        return area;
    };

    return (
        <>
            <StorytellingLayout>
                {/* <Head>
                    <title>{AREA?.title} | Dashboard | DBW</title>
                    <meta name="description" content="DBW description" />
                    <link rel="icon" href="/favicon.ico" />
                </Head> */}
                <MetaHeadSEO metaTitle={metaTitle} metaDescription={metaDescription} />
                {/* <OneAreaPage areas={areas} area={AREA} areaID={sid[0]} /> */}

                {AREA ? (
                    <OneAreaPage areas={areas} area={AREA} areaID={sid[0]} />
                ) : (
                    <div style={{ paddingTop: 80, paddingBottom: 80 }}>
                        {" "}
                        <Preloader type={"linear"} />
                    </div>
                )}
            </StorytellingLayout>
        </>
    );
};

export async function getStaticProps(props) {
    const { locale, params } = props;
    const { sid } = params;
    const areas = await getHomepageAreasFromAPI();

    const area =
        areas instanceof Array
            ? {
                  ...areas?.find((a) => a.areaID?.toString() === sid[0]?.toString()),
                  id: Number(sid[0] || 0),
              }
            : {};

    let title = TranslationFromJson(area, "name", { language: locale });

    const _metas = GenerateMeta({ pageId: "dashboard", title, locale });
    const { metaTitle, metaDescription } = _metas || {};

    return {
        props: {
            areas,
            area,
            sid,
            metaTitle,
            metaDescription,
            ...(await serverSideTranslations(locale, ["common"])),
            namespacesRequired: ["common"],
        },
        revalidate: false,
    };
}

export async function getStaticPaths() {
    // const areas = await getHomepageAreasFromAPI();
    // const paths = (areas instanceof Array ? areas : []).map((area) => ({
    //     params: { sid: [`${area.id}`], id: area.id },
    // }));

    // return { paths, fallback: "blocking" };
    return { paths: [], fallback: "blocking" };
}

export default Storytelling;
